import { Service } from "@seriously-rad/seriouslyrad-framework-core/Service";
import { IUserNotificationManager } from "./UserNotificationManager";

export class UserNotificationManagerService extends Service<IUserNotificationManager>
{
}